import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQTableSortSearch from '../../components/table-sort-search';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import { BREADCRUMB_ROOT } from '../../common/config';

const TableSortSearchDemoPage = () => {
  const attributes = [
    {
      attribute: 'search',
      type: 'string',
      default: "''",
      description: 'Placeholder text for the search input.',
    },
    {
      attribute: 'children',
      type: 'React.ReactNode',
      default: 'undefined',
      description: 'The table content, including <thead> and <tbody>.',
    },
    {
      attribute: 'className',
      type: 'string',
      default: "''",
      description: 'Additional class names for custom styling.',
    },
  ];

  const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
    {
      columnId: 'attribute',
      renderHeaderCell: () => 'Attribute',
      renderCell: (item) => item.attribute,
    },
    {
      columnId: 'type',
      renderHeaderCell: () => 'Type',
      renderCell: (item) => <code>{item.type}</code>,
    },
    {
      columnId: 'default',
      renderHeaderCell: () => 'Default',
      renderCell: (item) => <code>{item.default}</code>,
    },
    {
      columnId: 'description',
      renderHeaderCell: () => 'Description',
      renderCell: (item) => item.description,
    },
  ];

  const tableCodeSnippet = `
import React from 'react';
import { UQTableSortSearch } from '@uniqconsulting/ui';

<UQTableSortSearch search="Search in Table" className="uq-table">
  <thead>
    <tr>
      <th>Name</th>
      <th>Age</th>
      <th>Country</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>John Doe</td>
      <td>28</td>
      <td>USA</td>
    </tr>
    <tr>
      <td>Jane Smith</td>
      <td>34</td>
      <td>Canada</td>
    </tr>
    <tr>
      <td>Sam Wilson</td>
      <td>23</td>
      <td>UK</td>
    </tr>
  </tbody>
</UQTableSortSearch>
`;

  return (
    <>
      <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Table Sort Search']} />
      <h1>UQTableSortSearch Demo</h1>
      <UQSpacer size="m" />

      {/* Description */}
      <h2>Description</h2>
      <p>
        The <code>UQTableSortSearch</code> component provides a searchable and sortable table. Users can search for specific rows and sort columns by clicking on the headers.
      </p>
      <UQSpacer size="m" />

      {/* Attributes Table */}
      <h2>Attributes</h2>
      <UQSpacer size="s" />
      <UQDataGrid
        items={attributes}
        columns={attributeColumns}
        sortable={false}
        selectionMode="none"
      />
      <UQSpacer size="m" />

      {/* Live Demo */}
      <h2>Live Demo</h2>
      <UQSpacer size="s" />
      <UQTableSortSearch search="Search in Table" className="uq-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>John Doe</td>
            <td>28</td>
            <td>USA</td>
          </tr>
          <tr>
            <td>Jane Smith</td>
            <td>34</td>
            <td>Canada</td>
          </tr>
          <tr>
            <td>Sam Wilson</td>
            <td>23</td>
            <td>UK</td>
          </tr>
        </tbody>
      </UQTableSortSearch>
      <UQSpacer size="s" />
      <UQCode code={tableCodeSnippet} enableCopy />
    </>
  );
};

export default TableSortSearchDemoPage;